import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import './index.css';
import DevoteamAuthProvider from './contexts/auth';
import { router } from './routes';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <DevoteamAuthProvider>
        <RouterProvider router={router} />
      </DevoteamAuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
